import { Button } from '@design-system/components/button/button';
import { faShareNodes } from '@fortawesome/pro-regular-svg-icons';

export const ProgramLinks = ({
  onClick,
  isCreatorLive,
}: {
  onClick: () => void;
  isCreatorLive: boolean;
}) => {
  if (!isCreatorLive) {
    return <div>-</div>;
  }

  return (
    <Button
      variant="text"
      leftIcon={faShareNodes}
      onClick={onClick}
      className="mx-auto"
    >
      Share
    </Button>
  );
};
